import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useClickOutside from '@hooks/useClickOutside';

import { formatRangeValue } from '@features/filter/static/filterUtil';
import FilterInput from '@features/filter/v2/FilterInput';
import FilterName from '@features/filter/v2/FilterName';

import { clearSelectedFilterName, storeItemInGlobalFilter } from '@store/actions/FilterAction';

const FabricPriceRange = () => {
	const [priceRangeValue, setPriceRangeValue] = useState({ min: '', max: '' });
	const dispatch = useDispatch();
	const priceRengeRef = useRef(null);
	const { selectedCheckboxField } = useSelector((store) => store.slectedCheckBoxFieldStore);

	const onOutSideClick = () => {
		if (selectedCheckboxField === 'PRICE_RANGE_V2') dispatch(clearSelectedFilterName());
	};

	useClickOutside(priceRengeRef, onOutSideClick);

	const onApplyPriceRange = () => {
		let data = {
			name: 'FABRIC_PRICE_RANGE',
			minPrice: parseFloat(priceRangeValue.min),
			maxPrice: parseFloat(priceRangeValue.max),
			key: priceRangeValue,
			value: `Price: ${formatRangeValue(priceRangeValue, '$')}`,
			identifier: `priceRangeV2Ids`,
			type: 'INPUT_VALUE'
		};
		dispatch(storeItemInGlobalFilter(data));
		onClearInput();
	};

	const onClearInput = () => {
		setPriceRangeValue({ min: '', max: '' });
	};

	const onChangePrice = (e) => {
		const { name, value } = e.target;
		setPriceRangeValue((prev) => ({
			...prev,
			[name]: value
		}));
	};
	return (
		<div ref={priceRengeRef}>
			<FilterName type="PRICE_RANGE_V2" />
			<FilterInput
				inputValue={priceRangeValue}
				onChangeHandler={onChangePrice}
				onApplyHandler={onApplyPriceRange}
				placeHolderOne="$ Min"
				placeHolderTwo="$ Max"
				type="PRICE_RANGE_V2"
				onClearInputFields={onClearInput}
			/>
		</div>
	);
};

export default FabricPriceRange;
